import styles from './SourceSelector.module.css';

const SOURCE_TYPES = [
    { value: 'WAVE', label: 'Wave' },
    { value: 'HARMONIC', label: 'Harmonic' },
    { value: 'NOISE', label: 'Noise' },
];

const WAVEFORMS = [
    { value: 'SINE', label: 'Sine' },
    { value: 'TRIANGLE', label: 'Triangle' },
    { value: 'SAW', label: 'Saw' },
    { value: 'SQUARE', label: 'Square' },
];

const HARMONIC_PRESETS = [
    { value: 'SAW', label: 'Saw' },
    { value: 'SQUARE', label: 'Square' },
    { value: 'ORGAN', label: 'Organ' },
];

export default function SourceSelector({
    sourceType,
    waveform,
    harmonicPreset,
    onSourceTypeChange,
    onWaveformChange,
    onHarmonicPresetChange
}) {
    return (
        <div className={styles.container}>
            <div className={styles.row}>
                <span className={styles.label}>Source:</span>
                <div className={styles.buttonGroup}>
                    {SOURCE_TYPES.map(({ value, label }) => (
                        <button
                            key={value}
                            className={`${styles.button} ${sourceType === value ? styles.active : ''}`}
                            onClick={() => onSourceTypeChange(value)}
                        >
                            {label}
                        </button>
                    ))}
                </div>
            </div>

            {sourceType === 'WAVE' && (
                <div className={styles.row}>
                    <span className={styles.label}>Waveform:</span>
                    <div className={styles.buttonGroup}>
                        {WAVEFORMS.map(({ value, label }) => (
                            <button
                                key={value}
                                className={`${styles.button} ${styles.small} ${waveform === value ? styles.active : ''}`}
                                onClick={() => onWaveformChange(value)}
                            >
                                {label}
                            </button>
                        ))}
                    </div>
                </div>
            )}

            {sourceType === 'HARMONIC' && (
                <div className={styles.row}>
                    <span className={styles.label}>Preset:</span>
                    <div className={styles.buttonGroup}>
                        {HARMONIC_PRESETS.map(({ value, label }) => (
                            <button
                                key={value}
                                className={`${styles.button} ${styles.small} ${harmonicPreset === value ? styles.active : ''}`}
                                onClick={() => onHarmonicPresetChange(value)}
                            >
                                {label}
                            </button>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
}
